<template>
  <div class="mt-4  px-5">

    <h2>Unsere Waffen</h2>

    <weapon-table
        :weapon="comp_Weapons"
        user_club="ClubApp"
        @TransferWeaponOpen="TransferWeaponOpen"
        @TransferWeaponReturnDialog="TransferWeaponReturnDialog"
        @openAddToPool="openAddToPool"
    ></weapon-table>

    <v-dialog v-model="dialogAddToPool" max-width="500px">
      <v-card>
        <v-card-title>Vereinswaffe in Pool geben</v-card-title>
        <v-card-text>
          <v-alert type="info" outlined>
            Diese Waffe wird allen Mitgliedern des Vereins im Waffenpool zur Verfügung gestellt.
          </v-alert>
          <v-textarea
            v-model="poolData.notes"
            label="Hinweise (optional)"
            outlined
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogAddToPool = false">Abbrechen</v-btn>
          <v-btn color="primary" @click="addWeaponToPool">In Pool geben</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTransferReturn" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Möchtest du die Waffe wieder zurücknehmen?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogTransferReturn = false">Abbrechen</v-btn>
          <v-btn color="blue darken-1" text @click="TransferWeaponReturn()">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="dialog_Transfer_to"
        width="800"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Waffe übertragen an:
        </v-card-title>
        <v-card-text>
          <v-container>
            <h3 class="mb-3">An wen möchten Sie die Waffe übertragen?</h3>
            <v-alert
                v-if="WeaponTransfer.Systems.length > 0"
                class="mb-3"
                type="info"
                color="deep-purple"
                outlined
                text>
              Mit überlassen werden die zugeordneten Wechselsysteme:
              <b>{{ WeaponTransfer.Systems.map(s => s.KurzT).join(', ') }}</b>.
              Sie stehen mit auf dem Überlassungsprotokoll.
            </v-alert>
            <v-row>
              <v-col>
                <v-text-field
                    label="Name"
                    v-model="WeaponTransfer.RecName"
                    outlined
                    :rules="[rules.required]"
                    append-icon="mdi-cloud-search"
                    @click:append="find_Transfer_Name"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                    label="Vorname"
                    v-model="WeaponTransfer.RecVorname"
                    outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                    label="Adresse"
                    v-model="WeaponTransfer.RecAddress"
                    outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                    label="PLZ"
                    v-model="WeaponTransfer.RecPLZ"
                    outlined
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                    label="Ort"
                    v-model="WeaponTransfer.RecOrt"
                    outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="dialog_Transfer_to = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="primary"
              text
              @click="Transfer_get_Reciever"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <weapon-transfer-searched-result
        :dialog-transfer-results="dialogTransferResults"
        @clicked="dialogTransferResults = false"
        @assumed="get_Data_from_Result_Dialog">
    </weapon-transfer-searched-result>

    <weapon-transfer-protokoll
        :dialog-transfer="dialogTransfer"
        :data="WeaponTransfer"
        @clicked="dialogTransfer = false"
    ></weapon-transfer-protokoll>

  </div>
</template>

<script>
import WeaponTable from "@/views/component/weaponTable";
import weaponTransferProtokoll from '@/views/component/weaponTransferProtokoll.vue';
import weaponTransferSearchedResult from '@/views/component/weaponTransferSearchedResult.vue';

export default {
  name: "weapon",
  components: {WeaponTable, weaponTransferProtokoll, weaponTransferSearchedResult},
  data: () => ({
    dialogTransfer: false,
    dialog_Transfer_to: false,
    dialogTransferResults: false,
    dialogTransferReturn: false,
    TextUeberlassung: "",

    rules: {
      required: value => !!value || 'Feld darf nicht leer sein!',
    },
    defaultItem: {
      Beschreibung: null,
      Hersteller: null,
      Kaliber: null,
      KurzT: null,
      LangT: null,
      Nummer: null,
      Erwerb: null,
      Erwerbformated: null,
      Gattung: {id: 1, value: 'KwGk'},
      NWRWID: null,
      WaffenDisziplin: null,
      weaponID: null,
    },
    WeaponTransfer: {
      Hersteller: '',
      Gattung: '',
      Kaliber: '',
      NWR_WID: '',
      Nummer: '',
      MyName: '',
      MyAddress: '',
      MyPLZ_ORT: '',
      MyNWRPID: '',
      MyWeaponID: '',
      RecName: '',
      RecVorname: '',
      RecAddress: '',
      RecPLZ: '',
      RecOrt: '',
      RecNWRPID: '',
      RecTransferUntil: null,
      RecObject: null,
      Systems: [],
    },
    WeaponPrepareDelete: {},

    WeaponReturn: {},
    dialogAddToPool: false,
    poolData: {
      weapon_id: null,
      notes: ''
    }
  }),

  computed: {
    comp_Weapons() {
      return this.$store.state.ClubApp.Weapons;
    },
    comp_ClubName() {
      return this.$store.getters['ClubAuth/isClubName'];
    },
    comp_Anschrift() {
      return this.$store.state.ClubAuth.club.strasse;
    },
    comp_PLZ_Ort() {
      return this.$store.state.ClubAuth.club.PLZ + ' ' + this.$store.state.ClubAuth.club.ort;
    },
    comp_Add_Month_to_Transfer_Date() {
      var date = new Date()
      date.setMonth(date.getMonth() + 1)
      date = date.toLocaleString([], {dateStyle: 'medium'});
      return date
    }
  },

  created() {
    this.$store.dispatch('ClubApp/getWeapons');
  },

  methods: {

    TransferWeaponOpen(item) {
      this.WeaponTransfer.Hersteller = item.Hersteller,
          this.WeaponTransfer.Gattung = item.Gattung,
          this.WeaponTransfer.Kaliber = item.Kaliber,
          this.WeaponTransfer.NWR_WID = item.NWR_WID,
          this.WeaponTransfer.Nummer = item.Nummer,
          this.WeaponTransfer.MyWeaponID = item.id,
          this.WeaponTransfer.MyName = this.comp_ClubName,
          this.WeaponTransfer.MyAddress = this.comp_Anschrift,
          this.WeaponTransfer.MyPLZ_ORT = this.comp_PLZ_Ort,
          this.WeaponTransfer.MyNWRPID = '',
          // Zugeordnete Wechselsysteme überlässt das Backend automatisch mit
          this.WeaponTransfer.Systems = this.comp_Weapons.filter(w =>
              Number(w.funktion_typ) === 2 && Number(w.parent_weapon_id) === Number(item.id)),
          this.WeaponTransfer.RecTransferUntil = this.comp_Add_Month_to_Transfer_Date

      this.dialog_Transfer_to = true;
    },
    TransferWeaponReturnDialog(item) {
      this.WeaponReturn = item;
      this.dialogTransferReturn = true;
    },
    TransferWeaponReturn() {
      let Data = {
        weapon_id: this.WeaponReturn.id,
        transfer_delete: 1
      }
      this.$store.dispatch('GeneralApp/weapon_transfer', Data)
          .then(this.dialogTransferReturn = false)
    },

    openAddToPool(item) {
      this.poolData.weapon_id = item.id;
      this.poolData.notes = '';
      this.dialogAddToPool = true;
    },
    addWeaponToPool() {
      this.$store.dispatch('ClubApp/addWeaponToClubPool', this.poolData)
        .then(() => {
          this.dialogAddToPool = false;
        });
    },
    get_Data_from_Result_Dialog(item) {

      this.WeaponTransfer.RecName = item.name,
          this.WeaponTransfer.RecVorname = item.vorname,
          this.WeaponTransfer.RecOrt = item.ort,
          this.WeaponTransfer.RecAddress = item.strasse,
          this.WeaponTransfer.RecPLZ = item.PLZ,
          this.WeaponTransfer.RecOrt = item.ort,
          this.WeaponTransfer.RecNWRPID = item.NWR_PID,
          this.WeaponTransfer.RecObject = item

      this.dialogTransferResults = false
    },
    find_Transfer_Name() {
      let Data = {
        Name: this.WeaponTransfer.RecName
      };
      if (this.WeaponTransfer.RecName !== '') {
        this.$store.dispatch('GeneralApp/search_users_clubs_Names', Data)
            .then(this.dialogTransferResults = true)
      }
    },
    Transfer_get_Reciever() {
      this.dialogTransfer = true;
      this.dialog_Transfer_to = false;
    },
  },
}
</script>

<style scoped>
</style>
